import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { H1Block } from "./H1Block";
import { H2Block } from "./H2Block";
import { H3Block } from "./H3Block";
import { H4Block } from "./H4Block";
import { H5Block } from "./H5Block";
import { H6Block } from "./H6Block";

export const headingsBlocks: BlockExportMapping = {
  h1: H1Block,
  h2: H2Block,
  h3: H3Block,
  h4: H4Block,
  h5: H5Block,
  h6: H6Block,
};
